module.exports = __webpack_public_path__ + "static/media/perfileria-ico.ebf2636c.svg";